/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Cookies from 'js-cookie';
const CURRENT_VISITOR_STORAGE_KEY = 'visitor';
const UNKNOWN_VISITOR_TYPE = 'unspecified';
const getFingerprint = async () => {
    const module = await import('@fingerprintjs/fingerprintjs');
    const FingerprintJS = module.default;
    const fp = await FingerprintJS.load();
    const fingerprint = await fp.get();
    return fingerprint;
};
export class PageVisitService {
    load() {
        const storedRawVisitor = sessionStorage.getItem(CURRENT_VISITOR_STORAGE_KEY);
        if (storedRawVisitor) {
            this._currentVisitor = JSON.parse(storedRawVisitor);
            this._currentVisitor.visitortypes = this.getVisitorTypes();
            return true;
        }
        return false;
    }
    async create() {
        const fingerprint = await getFingerprint();
        if (fingerprint) {
            this._currentVisitor = {
                id: fingerprint.visitorId,
                visitortypes: this.getVisitorTypes(),
            };
            this.save(this._currentVisitor);
        }
    }
    save(updatedVisitor) {
        sessionStorage.setItem(CURRENT_VISITOR_STORAGE_KEY, JSON.stringify(updatedVisitor));
    }
    getVisitorTypes() {
        const visitorTypeCookieMap = {
            OEP_li: 'authenticated-customer',
            'is-cfe-user': 'authenticated-employer',
            'is-chcp-user': 'authenticated-professional',
        };
        const visitortypes = Object.entries(visitorTypeCookieMap).reduce((matches, [key, value]) => {
            if (Cookies.get(key)) {
                matches.add(value);
            }
            return matches;
        }, new Set());
        if (visitortypes.has('authenticated-customer') && Boolean(window.mycignaMaintenanceMode)) {
            visitortypes.delete('authenticated-customer');
        }
        if (!visitortypes.size) {
            visitortypes.add(UNKNOWN_VISITOR_TYPE);
        }
        return [...visitortypes];
    }
    async getCurrentVisitor() {
        if (!this._currentVisitor) {
            const loaded = this.load();
            if (!loaded) {
                await this.create();
            }
        }
        return this._currentVisitor;
    }
    async matchesAudience(components) {
        let audienceCounter = 0;
        let audienceComponents;
        const isLayout = 'container-1' in components;
        const audienceTracker = [];
        if (isLayout) {
            audienceComponents = [];
            for (const component in components) {
                if (component.includes('container-')) {
                    audienceComponents.push(...components[component]);
                }
            }
        }
        else {
            audienceComponents = components;
        }
        await this.getCurrentVisitor();
        audienceComponents.forEach((component) => {
            if (!Object.prototype.hasOwnProperty.call(component, 'audience')) {
                audienceTracker.push({
                    audience: [],
                    html: Object.values(component)[0],
                });
            }
            else {
                const audienceTags = component.audience;
                const isSingleMatch = audienceTags.length === 1 &&
                    audienceTags.some((audienceTag) => this._currentVisitor.visitortypes.includes(audienceTag));
                if (isSingleMatch) {
                    audienceTracker.push(component);
                    audienceCounter += 1;
                }
            }
        });
        if (isLayout) {
            if (audienceCounter === 0) {
                return [];
            }
            audienceTracker.unshift({
                audience: [],
                html: components.htmlStart,
            });
            audienceTracker.push({
                audience: [],
                html: components.htmlEnd,
            });
            const layoutAudienceTracker = audienceTracker.reduce((layoutArr, defaultArr) => {
                layoutArr.html += defaultArr.html;
                return layoutArr;
            });
            return [layoutAudienceTracker];
        }
        return audienceTracker;
    }
}
//# sourceMappingURL=service.js.map